import Component from 'gia/Component';

export default class Header extends Component {
  constructor(element) {
    super(element);
    this.ref = {
      mobileMenu: {},
      buttonOpenMenu: {},
      buttonCloseMenu: {}
    };
  }

  mount() {
    let that = this;

    this.ref.buttonOpenMenu.addEventListener('click', function() {
      that.ref.mobileMenu.classList.add('translate-x-0');
    });

    this.ref.buttonCloseMenu.addEventListener('click', function() {
      that.ref.mobileMenu.classList.add('-translate-x-full');
      that.ref.mobileMenu.classList.remove('translate-x-0');
    });
  }


}